import { ReactNode } from 'react';

/** A section's explanation, folded away until asked for: the section shows what is in it, not how it works. */
export default function Help({ children, label = 'How this works' }: { children: ReactNode; label?: string }) {
  return (
    <details className="text-[15px] leading-[22px] mb-3">
      <summary className="cursor-pointer select-none text-accent hover:text-ink w-fit list-none [&::-webkit-details-marker]:hidden">
        {label}
      </summary>
      <div className="mt-2 max-w-[72ch] text-ink-2">{children}</div>
    </details>
  );
}
